<template>
  <section class="nopadding">
    <v-container grid-list-md class="nopadding">
      <v-layout row wrap>
        <v-flex>
          <Breadcrumb :items="items"></Breadcrumb>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { Breadcrumb } from '@/components';

export default {
  name: 'RastroMigas',
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
    Breadcrumb
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.nopadding {
  padding: 10px 24px 0px 24px !important;
}
</style>
